import React, { useState } from "react";
import CreateBiodata from "../CreateBiodata/index.js";

export default function FormSection({ onTemplateSelectChange }) {
  return (
    <section 
      id="create-biodata"
      className="py-16 bg-gradient-to-br from-gray-50 to-blue-50"
      aria-label="Create Your Biodata Form"
    >
      <div className="max-w-6xl mx-auto px-2 sm:px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-pink-500 to-purple-500 rounded-full mb-6">
            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
            </svg>
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4 abc-bold">
            Create Your Perfect Biodata
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto abc-regular">
            Fill in your details and create a beautiful biodata in minutes. Our form is designed to be simple and user-friendly.
          </p>
        </div>

        {/* Form Container */}
        <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
          {/* Form Header */}
          <div className="bg-gradient-to-r from-pink-500 to-purple-500 px-8 py-6">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="text-xl font-semibold text-white abc-semibold">
                  Biodata Information
                </h3>
                <p className="text-white/90 text-sm abc-regular">
                  Complete all sections to create your biodata
                </p>
              </div>
              <div className="flex items-center space-x-2 text-white/80">
                <div className="w-2 h-2 bg-white rounded-full"></div>
                <span className="text-sm abc-regular">Auto-save enabled</span>
              </div>
            </div>
          </div>

          {/* Form Content */}
          <div className="p-4 sm:p-6 lg:p-8">
            <CreateBiodata onTemplateSelectChange={onTemplateSelectChange} />
          </div>
        </div>

        {/* Help Section */}
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="text-center p-6 bg-white rounded-xl shadow-sm border border-gray-100">
            <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h4 className="font-semibold text-gray-900 mb-2 abc-semibold">Need Help?</h4>
            <p className="text-gray-600 text-sm abc-regular">
              Check our FAQ section for common questions and answers.
            </p>
          </div>

          <div className="text-center p-6 bg-white rounded-xl shadow-sm border border-gray-100">
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h4 className="font-semibold text-gray-900 mb-2 abc-semibold">100% Secure</h4>
            <p className="text-gray-600 text-sm abc-regular">
              Your data is never stored. We prioritize your privacy and security.
            </p>
          </div>

          <div className="text-center p-6 bg-white rounded-xl shadow-sm border border-gray-100">
            <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
              </svg>
            </div>
            <h4 className="font-semibold text-gray-900 mb-2 abc-semibold">Beautiful Templates</h4>
            <p className="text-gray-600 text-sm abc-regular">
              Choose from our collection of professionally designed templates.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
